<template>
  <div class="p-grid p-fluid">
    <Toast position="random" />
    <div class="p-col-12">
      <div class="p-lg-8">
        <h2>Email not verified</h2>
        <p>
          Please verify your email. You can resend the email by clicking the
          button below
        </p>
        <Button @click="resend()" label="Resend verification email" />
      </div>
    </div>
  </div>
</template>

<script>
import RegisterService from "../service/RegisterService.js";

export default {
  data() {
    return {
      email: null,
    };
  },
  created() {
    this.registerService = new RegisterService();
    this.email = this.$route.params.email;
  },
  methods: {
    async resend() {
      try {
        console.log(this.email);
        await this.registerService.resendRegistrationMail(this.email);
        this.$router.push({ name: "login" });
      } catch (error) {
        //special toast? - exception not visible by interceptor
        console.log(error);
        return;
      }
    },
  },
};
</script>

<style scoped>
</style>